
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  When a list of items is presented on multiple pages, the pagination component
  is used at the bottom of the list to indicate the number of pages, the current
  page and to allow users to navigate to the different pages.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Pager/Pagination2.jpg" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/Pager/Pagination%20-%20Mobile2.jpg 598w, https://inno-ecl.s3.amazonaws.com/media/images/EC/Pager/Pagination2.jpg 734w" alt="Anatomy of pagination" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory desktop`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory mobile`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Links to other pages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Links leading to pages and their corresponding value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Active selection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Represents the current page the user is on`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`"Next" link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Links to the next page; it is not displayed on the last page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`"Previous" link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Links to the previous page; it is not displayed on the first page`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`place the `}<strong parentName="li">{`pagination below`}</strong>{` the list of items`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't replace`}</strong>{` this component `}<strong parentName="li">{`with an ‘infinite scrolling’`}</strong>{` feature`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`use to break long lists`}</strong>{` that would create too much vertical scrolling in one page`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`don't use to break unrelated content on different pages`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Design`}</h3>
    <ul>
      <li parentName="ul">{`3 dots (…) is used to indicate that there are more pages in-between`}</li>
      <li parentName="ul">{`first and last pages are always displayed`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;